import React, { useEffect, useState } from 'react';
import moment from 'moment/moment';
import { useDispatch, useSelector } from 'react-redux';
import ChartTableHeader from './ChartTableHeader';
import { getOrdersMembersRequest } from '../../store/actions/dashboard';
import user from '../../assets/images/user.png';
import Loader from '../Loader';

function MembersBySales() {
  const [loading, setLoading] = useState(false);
  const ordersMembers = useSelector((state) => state.dashboard.ordersMembers);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getOrdersMembersRequest({
      startDate: moment().add(-1, 'month').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
    }));
  }, []);

  const sortData = async (reqData) => {
    setLoading(true);
    await dispatch(getOrdersMembersRequest(reqData));
    setLoading(false);
  };
  return (
    <div className="membersBySales chartTableContainer">
      <ChartTableHeader changeValue={sortData} title="Latest Orders" />
      <div>
        <table className="chartTable">
          <tbody>
            {!loading
              ? ordersMembers?.map((d, i) => (
                <tr key={d.customerId}>
                  <td className="index">{i + 1}</td>
                  <td className="memberInfo">
                    <div>
                      <div className="imageBlock">
                        <img src={d.avatar || user} alt="" />
                      </div>
                      <div>
                        <p className="name">
                          {d.fName}
                          {' '}
                          {d.lName}
                        </p>
                        {/* <p className="sickness">{d.lName}</p> */}
                      </div>
                    </div>
                  </td>
                </tr>
              )) : <Loader style={{ height: 200 }} />}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default MembersBySales;
